module.exports = __webpack_public_path__ + "static/main_logo-616d3c4f2f66bfbf761094b78d9890a5.png";